import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PushNotifications,
} from '@capacitor/push-notifications';
import { FCM } from '@capacitor-community/fcm';
import { Capacitor } from '@capacitor/core';
import { isInsideAppContainer } from './global-utils/vmFunctions/others';
import { dataInsightTrack } from './modules/data-insight/model/utils';

const FirebasePushNotifications = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState(null);
  // const [notificationData, setNotificationData] = useState(null);

  useEffect(() => {
    const initializePushNotifications = async () => {
      if (!isInsideAppContainer()) {
        console.warn('Push Notifications are only available on native platforms.');
        return;
      }

      try {
        // 1. Remove old listeners & register new ones BEFORE requesting permissions
        await PushNotifications.removeAllListeners();

        // Add listener for token registration
        await PushNotifications.addListener('registration', async (tokenData) => {
          console.log('Device Token:', tokenData.value);
          setToken(tokenData.value);

          // Handle iOS-specific token handling
          if (Capacitor.getPlatform() === 'ios') {
            try {
              const fcmToken = await FCM.getToken();
              console.log('FCM Token for iOS:', fcmToken.token);
              setToken(fcmToken.token);
            } catch (err) {
              console.error('Error getting FCM token for iOS:', err);
            }
          }

          // Subscribe to topics
          try {
            await FCM.subscribeTo({ topic: 'general' });
            // admin - subscribeTo admin, test, visitor
            // visitor - subscribeTo visitor
            // test - subscribeTo test
            console.log('Subscribed to topic: general');
          } catch (err) {
            console.error('Error subscribing to topic:', err);
            alert(`Error subscribing to topic: ${err instanceof Error ? err.message : err}`);
          }
        });

        await PushNotifications.addListener('registrationError', (error) => {
          console.error('Registration error: ', error);
        });

        // Listener for notification actions
        await PushNotifications.addListener(
          'pushNotificationActionPerformed',
          (action) => {
            dataInsightTrack({
              sourceApplicationAction: 'notification-open',
              sourceApplication: 'vmx',
              sourceApplicationContext: 'PushNotification',
              entityId: action?.notification?.data?.label || action?.notification?.data?.title,
              pageTitle: '',
              sourceApplicationUrl: '/notifications'
            });
            navigate('/notifications');
          }
        );

        // 2. Request permissions
        console.log('Requesting permissions...');
        const permission = await PushNotifications.requestPermissions();
        
        if (permission.receive === 'granted') {
          console.log('Push Notification permissions granted!');
          // 3. Register with APNs/FCM
          await PushNotifications.register();
        } else {
          alert('Push Notification permissions not granted.');
        }

      } catch (err) {
        console.error('Error during Push Notifications setup:', err);
      }
    };

    initializePushNotifications().catch((err) => {
      console.error('Unexpected error initializing push notifications:', err);
    });
  }, []);

  return null;
};

export default FirebasePushNotifications;
